export default __webpack_public_path__ + "static/tickets-bg-40a13a52550b96e814f2e911e1004c49.svg";